import React from "react";
import { FinishList } from "./subPages/FinishList";
import { useFinishContext } from "./context";
import { finishOperationsList } from "./constants/finish.constants";
import { UpdateFinish } from "./subPages/UpdateFinish";
import { AddFinish } from "./subPages/NewFinish";

export const FinishPage = () => {
  const { currentOperationPage } = useFinishContext();

  return (
    <>
      {currentOperationPage === finishOperationsList.listFinish && (
        <FinishList />
      )}{" "}
      {currentOperationPage === finishOperationsList.updateFinish && (
        <UpdateFinish />
      )}
      {currentOperationPage === finishOperationsList.newFinish && <AddFinish />}
    </>
  );
};
